import { render } from "./dashboard.vue?vue&type=template&id=255e8840&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=255e8840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255e8840"]])

export default __exports__